"use client";

import { ConfluentReferralSteps } from "@/configuration/groups/confluent-all-star/components/referral-steps";
import { ReferralWorkflowLayout } from "@/configuration/groups/confluent-all-star/components/referral-timeline";
import PatientCard from "@/src/components/cards/patient-card/patient-card";
import ReferralCard from "@/src/components/cards/referral-card/referral-card";
import type { Referral } from "@/src/models/documents/referral";
import type { Task } from "@/src/models/task";
import type { TaskApproval } from "@/src/models/task-approval";
import type { TaskStep } from "@/src/models/task-step";

export function ConfluentReferralInstructions({
  view,
  referral,
  task,
  taskSteps,
  pendingApproval,
}: {
  view: "information" | "steps";
  referral: Referral;
  task: Task;
  taskSteps: TaskStep[];
  pendingApproval: TaskApproval | null;
}) {
  if (view === "steps") {
    return (
      <ReferralWorkflowLayout>
        <ConfluentReferralSteps
          task={task}
          taskSteps={taskSteps}
          referral={referral}
          pendingApproval={pendingApproval}
        />
      </ReferralWorkflowLayout>
    );
  }

  return (
    <ReferralWorkflowLayout>
      <p className="text-sm text-muted-foreground">
        These are the patient and referral details recorded in Valerie. Review the Steps tab and verify the results in
        Clinicient before completing this task.
      </p>
      <PatientCard patient={referral.patient} />
      <ReferralCard referral={referral} isEditable />
    </ReferralWorkflowLayout>
  );
}
